import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { printReceipt } from "../lib/ticketPrint";
import { toast } from "sonner";

/**
 * Hook compartido para reimprimir tickets:
 * - carga configuración (/settings) una sola vez
 * - expone helpers para imprimir ventas ya cargadas o buscar por ID/folio
 */
export default function useTicketReprint() {
    const [settings, setSettings] = useState(null);
    const [loadingSettings, setLoadingSettings] = useState(false);

    useEffect(() => {
        setLoadingSettings(true);
        api.get("/settings")
            .then((r) => setSettings(r.data))
            .catch(() => {
                // silencioso: se volverá a intentar al imprimir
            })
            .finally(() => setLoadingSettings(false));
    }, []);

    const ensureSettings = async () => {
        if (settings || loadingSettings) return settings;
        setLoadingSettings(true);
        try {
            const { data } = await api.get("/settings");
            setSettings(data);
            return data;
        } catch (e) {
            toast.error(formatApiError(e));
            throw e;
        } finally {
            setLoadingSettings(false);
        }
    };

    const reprint = async (sale) => {
        if (!sale) {
            toast.error("No hay datos de la venta para imprimir");
            return;
        }
        try {
            const s = await ensureSettings();
            await printReceipt(sale, s || {});
        } catch (e) {
            // el error ya se notificó en ensureSettings o printReceipt
            if (e?.message && !/configuración/i.test(e.message)) {
                toast.error(e.message);
            }
        }
    };

    return {
        settings,
        loadingSettings,
        reprint,
        ensureSettings,
    };
}

